import { render } from "./depositUser.vue?vue&type=template&id=e522c882&scoped=true"
import script from "./depositUser.vue?vue&type=script&lang=js"
export * from "./depositUser.vue?vue&type=script&lang=js"

import "./depositUser.vue?vue&type=style&index=0&id=e522c882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e522c882"]])

export default __exports__